import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, List, ListItem, ListItemText, Button, TextField, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from '../../components/Common/LoadingSpinner';
import { apiService } from '../../services/apiService';

const Nominations: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [nominations, setNominations] = useState<any[]>([]);
  const [congress, setCongress] = useState<string>('');

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const params: any = { limit: 50, offset: 0 };
      if (congress) params.congress = Number(congress);
      const resp = await apiService.getNominations(params);
      const data = resp.data || {};
      const list = data.nominations || data.items || [];
      setNominations(Array.isArray(list) ? list : []);
    } catch (e: any) {
      console.error('Failed to load nominations', e);
      setError('Failed to load nominations');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
          <Typography variant="h5" sx={{ flexGrow: 1 }}>Nominations</Typography>
          <TextField
            label="Congress (optional)"
            size="small"
            value={congress}
            onChange={(e) => setCongress(e.target.value)}
            sx={{ width: 200 }}
          />
          <Button variant="contained" onClick={fetchData}>Search</Button>
        </Stack>
      </Paper>

      {loading ? (
        <LoadingSpinner message="Loading nominations..." />
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <Paper>
          <List>
            {nominations.length === 0 ? (
              <ListItem>
                <ListItemText primary="No nominations found" />
              </ListItem>
            ) : (
              nominations.map((n: any, idx: number) => {
                const src = n.nomination || n;
                const cong = src.congress || src.nominationCongress || src.session || '';
                const number = src.number || src.nominationNumber || src.nomination || '';
                const description = src.description || src.nomineeFullName || src.organization || '';
                const latestAction = src.latestAction?.text || src.status || '';
                return (
                  <ListItem key={idx} divider secondaryAction={
                    <Button size="small" onClick={() => navigate(`/nominations/${cong}/${number}`)}>View</Button>
                  }>
                    <ListItemText
                      primary={`Nomination ${number} (Congress ${cong})`}
                      secondary={latestAction || description}
                    />
                  </ListItem>
                );
              })
            )}
          </List>
        </Paper>
      )}
    </Box>
  );
};

export default Nominations;
